export interface GallerySlide {
  src: string
  alt: string
  title: string
  caption: string
}

const IMG_BASE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/6d5da149-c745-4a53-bdb0-43e6ca2d13ac/product-uploads/'

export const insideItems: string[] = [
  'Voltage, current & resistance',
  'Ohm’s law & the power formula wheel',
  'Series, parallel & combination circuits',
  'AC waveforms & power factor',
  'Electrical PPE & arc flash basics',
  'Lockout/tagout & live-dead-live testing',
  'Multimeter & clamp meter technique',
  'Conductor colors: NEC vs. IEC',
  'Panels, breakers & consumer units',
  'GFCI / RCD & AFCI protection',
  'Receptacle & switch wiring',
  'Three-way & four-way switching',
  'Grounding vs. bonding',
  'Three-phase wye & delta systems',
  'Transformers & kVA sizing',
  'Motor nameplates, speed & slip',
  'Contactors, relays & overloads',
  'Start/stop & forward/reverse control',
  'Schematics, ladder & one-line diagrams',
  'Insulation resistance testing',
  'Systematic troubleshooting & half-split',
  'Open circuits, shorts & ground faults',
  'PLC I/O, sinking vs. sourcing',
  'Ladder logic, timers & counters',
  'Analog 4–20 mA & 0–10 V signals',
  'VFD wiring, parameters & faults',
  'Smart & building automation systems',
  'Lesson plans & demonstrations',
  '❌/✅ comparisons',
  'Teaching cues, drills & quick checks',
]

/** Carousel slides — one real page per volume (Vol 1 to Vol 6). */
export const gallerySlides: GallerySlide[] = [
  {
    src: `${IMG_BASE}mcp_3151252a-5255-420d-a47f-2b772507654a_1793890173563.jpg`,
    alt: 'Electrical Technology Instructor Atlas — Vol 1 page: Ohm’s Law triangle with three worked examples',
    title: 'Vol 1 — Ohm’s Law',
    caption: 'Vol 1 — Electrical Fundamentals, Circuit Theory & Electrical Safety: the V = I × R triangle, three worked examples, an instructor cue, a trainer drill and a quick check.',
  },
  {
    src: `${IMG_BASE}mcp_3151252a-5255-420d-a47f-2b772507654a_1793890176734.jpg`,
    alt: 'Electrical Technology Instructor Atlas — Vol 2 page: Receptacle Anatomy, NEMA 5-15 / 5-20 and IEC/UK socket outlet',
    title: 'Vol 2 — Receptacle Anatomy',
    caption: 'Vol 2 — Residential Electrical Wiring, Installations & Circuit Protection: NEMA 5-15 / 5-20 and IEC/UK outlets labeled, conductor colors, tamper-resistant shutters and a quick check.',
  },
  {
    src: `${IMG_BASE}mcp_3151252a-5255-420d-a47f-2b772507654a_1793890179436.jpg`,
    alt: 'Electrical Technology Instructor Atlas — Vol 3 page: Motor Speed & Slip, synchronous speed table for 50 and 60 Hz',
    title: 'Vol 3 — Motor Speed & Slip',
    caption: 'Vol 3 — Commercial & Industrial Electrical Systems, Motors & Controls: synchronous speed formula, 50/60 Hz speed table, slip calculation, a quick check and a nameplate drill.',
  },
  {
    src: `${IMG_BASE}mcp_3151252a-5255-420d-a47f-2b772507654a_1793890186440.jpg`,
    alt: 'Electrical Technology Instructor Atlas — Vol 4 page: Reading a Schematic, six key rules for tracing a circuit',
    title: 'Vol 4 — Reading a Schematic',
    caption: 'Vol 4 — Electrical Diagrams, Testing, Troubleshooting & Fault Diagnosis: six numbered rules for tracing a circuit from L1 to L2, a ladder drill and a quick check.',
  },
  {
    src: `${IMG_BASE}mcp_3151252a-5255-420d-a47f-2b772507654a_1793890189349.jpg`,
    alt: 'Electrical Technology Instructor Atlas — Vol 5 page: Analog Inputs & Outputs, 4–20 mA and 0–10 V scaling',
    title: 'Vol 5 — Analog Inputs & Outputs',
    caption: 'Vol 5 — Industrial Automation, PLCs, Variable Frequency Drives & Smart Electrical Systems: 4–20 mA and 0–10 V scaling, live zero, ❌/✅, an instructor cue and a PLC drill.',
  },
  {
    src: `${IMG_BASE}mcp_3151252a-5255-420d-a47f-2b772507654a_1793890192756.jpg`,
    alt: 'Electrical Technology Instructor Atlas — Vol 6 page: 16-Week Electrical Course Calendar with topics, labs and assessments',
    title: 'Vol 6 — 16-Week Course Calendar',
    caption: 'Vol 6 — Electrical Instruction, Workshop Training & Practical Assessments: a week-by-week course plan from lab safety and Ohm’s law to PLCs, VFDs and the final practical.',
  },
]
